<template>
  <div
    v-if="loading"
    class="action-btn actb actb_loading no-events"
  ></div>
  <div
    v-else
    v-ripple="!hasResult"
    class="action-btn actb"
    :style="cssStyle"
    :class="[{ actb_hovered: isHovered }, { actb_result: hasResult }, correctness_group.res_group]"
    @click="$emit('click', action)"
  >
    <div
      v-if="(hasResult || hasCheatFrequency) && action.actions"
      class="actb_grouped-actions mdi mdi-dots-vertical icon_btn pa-1 csst"
      @mousedown.stop
      @click.stop="open = !open"
    >
      <div
        class="csst_content text-nowrap"
        :style="`right: 0; transform: translate(0, calc(-100% - 0.5em)`"
        v-html="$t('tooltips.action_grouped_actions')"
      />
      <div
        :class="open ? 'cssm_content cssm_content_visible' : 'cssm_content_not-visible'"
        style="
          position: fixed;
          z-index: 10;
          transform: translate(calc(-1 * 50% + 0.875em), calc(-1 * 50% - 1em));
        "
        @click.stop
      >
        <div
          v-if="open"
          v-click-outside="() => (open = false)"
          class="gw_menu ha-street-blocks"
          style="
            padding: 0.75em;
            max-height: 32rem;
            --width: auto;
            --clr-back: var(--clr-black-1);
            display: table;
          "
        >
          <HaActionMetrics
            v-for="(aa, aIdx) in action.actions"
            :key="`${aIdx}_${aa.code}`"
            style="--gap: 0; padding: 0.5rem; --ha-aa-width: 8rem"
            :action="aa"
            :isNa="action.correctness === 'na'"
            :showBetsIn="showBetsIn"
            :bettingInfo
            :usePreselected="hasResult"
            :hasBBPot="true"
            :open="true"
          />
        </div>
      </div>
    </div>

    <div
      class="actb_back"
      :style="cssStyle"
    >
      <div class="actb_back_overlay"></div>
    </div>
    <i
      v-if="correctness_group.icon"
      v-show="hasResult"
      class="mdi actb_icon"
      :class="correctness_group.icon"
      :style="`color: var(${correctness_group.color})`"
    >
    </i>
    <div
      v-if="!hasResult && hasCheatFrequency"
      :data-tst="`action_cheat_frequency_${action.code}`"
      class="actb_cheat-frequency csst csst_nm"
    >
      {{ numFixedUnit(action.frequency * 100, 'strategy') }}%

      <div
        class="csst_content text-nowrap"
        style="position: absolute; z-index: 10; right: 0; top: -2rem"
        v-html="
          $t('tooltips.turn_off_hints_key', {
            key: $store.getters.hotkeys.practice_hero_frequency.displayCombination,
          })
        "
      ></div>
    </div>
    <div class="actb_name">
      <div class="actb_display-name">
        {{ action.display_name || $t(`browse.${action.group_display_name}`) }}
        <span v-html="getBetHtml({ showBetsIn, a: action, simple: false })"></span>
      </div>
    </div>
    <div
      v-if="hasResult && correctness_group.res_id !== 'na'"
      class="actb_result_values"
    >
      <div
        v-show="l_hasFreq"
        class="actb_frequency"
      >
        {{ numFixedUnit(action.frequency * 100, 'strategy') }} %
      </div>
      <div
        v-show="l_hasEv"
        class="actb_ev"
        v-html="
          getEvHtml({
            ...bettingInfo,
            ignoreIcmEvIntercept: true,
            ev: action.ev,
            player: 'hero',
            unit: ' ev',
            percentUnit: ' %',
            dollarUnit: ' $',
            percent_css_class: '',
          })
        "
      ></div>
    </div>
    <div
      v-else-if="hasResult && correctness_group.res_id === 'na'"
      class="actb_result_values"
    >
      N/A
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import HaActionMetrics from '@/components/AnalyzeStreetBlocks/HaActionMetrics'

export default {
  name: 'ActionBtn',
  components: {
    HaActionMetrics,
  },
  mixins: [format_mix],
  // mixins: [format_mix, float_mix],
  props: {
    action: [Object, Number, String],
    showBetsIn: String,
    bettingInfo: Object,
    hasResult: Boolean,
    hasEv: Boolean,
    hasFreq: Boolean,
    isHovered: Boolean,
    hasCheatFrequency: Boolean,
    hasHighlight: Boolean,
    hasDefaultColors: { type: Boolean, default: true },
    loading: { type: Boolean, default: true },
  },
  emits: ['click'],
  data() {
    return {
      open: false,
    }
  },
  computed: {
    l_hasFreq() {
      return !this.hasFreq ? false : (this.action.frequency ?? '').toString()
    },
    l_hasEv() {
      return !this.hasEv ? false : (this.action.ev ?? '').toString()
    },
    correctness_group() {
      return this.action?.correctness_group || {}
    },
    color() {
      return this.correctness_group?.color || '--clr-default'
    },
    // colorScheme() {
    //   return this.hasDefaultColors && !this.hasResult ? '-default' : ''
    // },
    cssStyle() {
      let res = {}
      if (this.hasResult && this.hasHighlight) {
        res = {
          '--clr-back': `var(${this.color})`,
          // '--clr-back': `var(${this.color}${this.colorScheme})`,
        }
      } else if (!this.hasResult) {
        res = {
          '--clr-back': `${this.action?.hex || ''}`,
          // '--clr-back': `var(${this.action?.css_var || ''}${this.colorScheme})`,
        }
      }
      // console.log(res)
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.actb {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: var(--clr-action_text);
  flex: 1;
  height: 4.25em;
  padding: 0 1.5em;
  flex-shrink: 0;
  text-shadow: var(--action-btn-text-shadow);

  --clr-default: var(--clr-primary);
  --clr-back: var(--clr-trainer_action_btn_default_background);
  --back-opacity: 0;

  --border-width: clamp(2px, 0.275em, 3px);

  // box-shadow: 0px 4px 8px 1px var(--clr-black-0);
  // box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  // box-shadow: 0px 4px 8px 1px red;

  &_hovered {
    .actb_back_overlay {
      opacity: 0.5;
      transition: 0.2s;
    }
  }
  &_bordered {
    box-shadow: 0px 0px 0px 1px var(--clr-black-3);
  }
  &_loading {
    opacity: 1;
    animation: opacityPulse 2s infinite;
    --clr-back: var(--clr-white-0);
    background: var(--clr-back);
    @keyframes opacityPulse {
      0% {
        opacity: 0.05;
      }
      50% {
        opacity: 0.1;
      }
      100% {
        opacity: 0.05;
      }
    }
  }
  &_cheat-frequency {
    position: absolute;
    right: 0.5em;
    bottom: 0.25em;
    font-size: 0.8em;
    font-weight: 700;
  }
  &_back {
    height: 100%;
    width: 100%;
    position: absolute;
    border-radius: 3px;
    left: 0;
    top: 0;
    background: var(--clr-back);
    border: solid var(--border-width) transparent;
    &_overlay {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      border-radius: 4px;
      z-index: 0;
      // transition: 0.2s;
      // background: var(--clr-trainer_action_btn_default_background);
      background: var(--clr-black-1);
      opacity: var(--back-opacity);
    }
  }
  &_icon {
    // padding: 0 0.5rem 0 1em;
    padding: 0 1rem 0 0;
    // padding: 0 1rem 0 1.5em;

    position: relative;
    font-size: 2em;
    display: flex;
    color: var(--clr-back);
  }
  &_name {
    position: relative;
    font-weight: 700;
    z-index: 2;
    line-height: 1.1;

    // display: grid;
    // grid-template-columns: 1fr;
    text-transform: uppercase;
    text-align: center;

    align-items: center;
  }
  &_result {
    // pointer-events: none;
    --clr-back: var(--clr-trainer_action_btn_default_background);
    // .actb_back {
    //   opacity: 0;
    // }
    cursor: default !important;
    .actb_back_overlay {
      // opacity: 1;
      background: var(--clr-trainer_action_btn_default_background);
      --back-opacity: 1;
    }
    .actb_name {
      display: flex;
      text-align: left;
      flex: 1;
    }
    &_values {
      position: relative;
      padding: 0 0 0 1em;
      // padding: 0 1rem 0 0.5em;
      text-align: right;
      white-space: nowrap;
      text-transform: uppercase;
      font-weight: 700;
    }
  }
  &_grouped-actions {
    position: absolute !important;
    top: 0.125rem;
    right: 0rem;
    z-index: 4;
  }
}
@media (hover: hover) and (pointer: fine) {
  .actb {
    &:hover {
      cursor: pointer;
      --back-opacity: 0.5;
      .actb_back_overlay {
        transition: 0.2s;
      }
    }
  }
}
</style>
